<template>
  <div class="dashboard"></div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Redirectional',
  created() {
    if (this.$route.query == 'dashboard') {
      this.$router.push('/')  
    } else {
      this.$router.push(`${this.$route.query}`)
    }
  },
};
</script>
